module.exports = [
  {
    "geoid": "22051020101",
    "LE": 76
  },
  {
    "geoid": "22051020102",
    "LE": 81
  },
  {
    "geoid": "22051020201",
    "LE": 80
  },
  {
    "geoid": "22051020203",
    "LE": 82
  },
  {
    "geoid": "22051020301",
    "LE": 81
  },
  {
    "geoid": "22051020302",
    "LE": 80
  },
  {
    "geoid": "22051020303",
    "LE": 80
  },
  {
    "geoid": "22051020400",
    "LE": 80
  },
  {
    "geoid": "22051020502",
    "LE": 79
  },
  {
    "geoid": "22051020507",
    "LE": 79
  },
  {
    "geoid": "22051020508",
    "LE": 80
  },
  {
    "geoid": "22051020511",
    "LE": 80
  },
  {
    "geoid": "22051020512",
    "LE": 78
  },
  {
    "geoid": "22051020513",
    "LE": 79
  },
  {
    "geoid": "22051020514",
    "LE": 82
  },
  {
    "geoid": "22051020515",
    "LE": 78
  },
  {
    "geoid": "22051020516",
    "LE": 74
  },
  {
    "geoid": "22051020517",
    "LE": 79
  },
  {
    "geoid": "22051020600",
    "LE": 74
  },
  {
    "geoid": "22051020700",
    "LE": 68
  },
  {
    "geoid": "22051021000",
    "LE": 75
  },
  {
    "geoid": "22051021100",
    "LE": 74
  },
  {
    "geoid": "22051021200",
    "LE": 75
  },
  {
    "geoid": "22051021300",
    "LE": 77
  },
  {
    "geoid": "22051021400",
    "LE": 80
  },
  {
    "geoid": "22051021500",
    "LE": 72
  },
  {
    "geoid": "22051021600",
    "LE": 78
  },
  {
    "geoid": "22051021700",
    "LE": 77
  },
  {
    "geoid": "22051021801",
    "LE": 78
  },
  {
    "geoid": "22051021803",
    "LE": 75
  },
  {
    "geoid": "22051021804",
    "LE": 74
  },
  {
    "geoid": "22051021900",
    "LE": 77
  },
  {
    "geoid": "22051022001",
    "LE": 75
  },
  {
    "geoid": "22051022002",
    "LE": 80
  },
  {
    "geoid": "22051022101",
    "LE": 81
  },
  {
    "geoid": "22051022102",
    "LE": 80
  },
  {
    "geoid": "22051022200",
    "LE": 74
  },
  {
    "geoid": "22051022301",
    "LE": 80
  },
  {
    "geoid": "22051022302",
    "LE": 75
  },
  {
    "geoid": "22051022303",
    "LE": 78
  },
  {
    "geoid": "22051022400",
    "LE": 81
  },
  {
    "geoid": "22051022500",
    "LE": 81
  },
  {
    "geoid": "22051022600",
    "LE": 82
  },
  {
    "geoid": "22051022700",
    "LE": 81
  },
  {
    "geoid": "22051022800",
    "LE": 78
  },
  {
    "geoid": "22051022900",
    "LE": 75
  },
  {
    "geoid": "22051023001",
    "LE": 80
  },
  {
    "geoid": "22051023002",
    "LE": 82
  },
  {
    "geoid": "22051023003",
    "LE": 80
  },
  {
    "geoid": "22051023100",
    "LE": 79
  },
  {
    "geoid": "22051023200",
    "LE": 73
  },
  {
    "geoid": "22051023300",
    "LE": 76
  },
  {
    "geoid": "22051023400",
    "LE": 77
  },
  {
    "geoid": "22051023500",
    "LE": 76
  },
  {
    "geoid": "22051023600",
    "LE": 73
  },
  {
    "geoid": "22051023700",
    "LE": 72
  },
  {
    "geoid": "22051023800",
    "LE": 74
  },
  {
    "geoid": "22051023901",
    "LE": 77
  },
  {
    "geoid": "22051023902",
    "LE": 80
  },
  {
    "geoid": "22051023903",
    "LE": 80
  },
  {
    "geoid": "22051023904",
    "LE": 80
  },
  {
    "geoid": "22051024001",
    "LE": 77
  },
  {
    "geoid": "22051024100",
    "LE": 76
  },
  {
    "geoid": "22051024201",
    "LE": 74
  },
  {
    "geoid": "22051024202",
    "LE": 79
  },
  {
    "geoid": "22051024300",
    "LE": 78
  },
  {
    "geoid": "22051024400",
    "LE": 75
  },
  {
    "geoid": "22051024500",
    "LE": 77
  },
  {
    "geoid": "22051024600",
    "LE": 74
  },
  {
    "geoid": "22051024700",
    "LE": 70
  },
  {
    "geoid": "22051024800",
    "LE": 82
  },
  {
    "geoid": "22051024900",
    "LE": 68
  },
  {
    "geoid": "22051025001",
    "LE": 74
  },
  {
    "geoid": "22051025002",
    "LE": 73
  },
  {
    "geoid": "22051025003",
    "LE": 75
  },
  {
    "geoid": "22051025102",
    "LE": 77
  },
  {
    "geoid": "22051025103",
    "LE": 78
  },
  {
    "geoid": "22051025104",
    "LE": 77
  },
  {
    "geoid": "22051025201",
    "LE": 73
  },
  {
    "geoid": "22051025202",
    "LE": 74
  },
  {
    "geoid": "22051025300",
    "LE": 76
  },
  {
    "geoid": "22051025400",
    "LE": 74
  },
  {
    "geoid": "22051025500",
    "LE": 75
  },
  {
    "geoid": "22051025600",
    "LE": 74
  },
  {
    "geoid": "22051025700",
    "LE": 69
  },
  {
    "geoid": "22051025800",
    "LE": 70
  },
  {
    "geoid": "22051025900",
    "LE": 75
  },
  {
    "geoid": "22051026000",
    "LE": 69
  },
  {
    "geoid": "22051026100",
    "LE": 71
  },
  {
    "geoid": "22051026300",
    "LE": 75
  },
  {
    "geoid": "22051026400",
    "LE": 73
  },
  {
    "geoid": "22051026500",
    "LE": 72
  },
  {
    "geoid": "22051026600",
    "LE": 71
  },
  {
    "geoid": "22051026700",
    "LE": 71
  },
  {
    "geoid": "22051026800",
    "LE": 68
  },
  {
    "geoid": "22051026900",
    "LE": 72
  },
  {
    "geoid": "22051027000",
    "LE": 71
  },
  {
    "geoid": "22051027100",
    "LE": 72
  },
  {
    "geoid": "22051027200",
    "LE": 72
  },
  {
    "geoid": "22051027501",
    "LE": 73
  },
  {
    "geoid": "22051027502",
    "LE": 73
  },
  {
    "geoid": "22051027601",
    "LE": 73
  },
  {
    "geoid": "22051027602",
    "LE": 72
  },
  {
    "geoid": "22051027701",
    "LE": 73
  },
  {
    "geoid": "22051027703",
    "LE": 71
  },
  {
    "geoid": "22051027803",
    "LE": 72
  },
  {
    "geoid": "22051027804",
    "LE": 77
  },
  {
    "geoid": "22051027805",
    "LE": 78
  },
  {
    "geoid": "22051027806",
    "LE": 78
  },
  {
    "geoid": "22051027807",
    "LE": 79
  },
  {
    "geoid": "22051027809",
    "LE": 76
  },
  {
    "geoid": "22051027811",
    "LE": 75
  },
  {
    "geoid": "22051027812",
    "LE": 70
  },
  {
    "geoid": "22051027901",
    "LE": 75
  },
  {
    "geoid": "22051027902",
    "LE": 73
  },
  {
    "geoid": "22051028000",
    "LE": 76
  },
  {
    "geoid": "22051028100",
    "LE": 71
  },
  {
    "geoid": "22051028200",
    "LE": 72
  },
  {
    "geoid": "22071000100",
    "LE": 78
  },
  {
    "geoid": "22071000200",
    "LE": 73
  },
  {
    "geoid": "22071000300",
    "LE": 71
  },
  {
    "geoid": "22071000400",
    "LE": 75
  },
  {
    "geoid": "22071000601",
    "LE": 71
  },
  {
    "geoid": "22071000602",
    "LE": 77
  },
  {
    "geoid": "22071000603",
    "LE": 72
  },
  {
    "geoid": "22071000604",
    "LE": 73
  },
  {
    "geoid": "22071000605",
    "LE": 70
  },
  {
    "geoid": "22071000606",
    "LE": 75
  },
  {
    "geoid": "22071000607",
    "LE": 80
  },
  {
    "geoid": "22071000611",
    "LE": 74
  },
  {
    "geoid": "22071000612",
    "LE": 80
  },
  {
    "geoid": "22071000613",
    "LE": 72
  },
  {
    "geoid": "22071000615",
    "LE": 79
  },
  {
    "geoid": "22071000616",
    "LE": 75
  },
  {
    "geoid": "22071000617",
    "LE": 73
  },
  {
    "geoid": "22071000618",
    "LE": 82
  },
  {
    "geoid": "22071000702",
    "LE": 73
  },
  {
    "geoid": "22071000800",
    "LE": 71
  },
  {
    "geoid": "22071000904",
    "LE": 66
  },
  {
    "geoid": "22071001100",
    "LE": 72
  },
  {
    "geoid": "22071001200",
    "LE": 71
  },
  {
    "geoid": "22071001301",
    "LE": 68
  },
  {
    "geoid": "22071001302",
    "LE": 62
  },
  {
    "geoid": "22071001401",
    "LE": 71
  },
  {
    "geoid": "22071001402",
    "LE": 68
  },
  {
    "geoid": "22071001500",
    "LE": 72
  },
  {
    "geoid": "22071001701",
    "LE": 78
  },
  {
    "geoid": "22071001702",
    "LE": 75
  },
  {
    "geoid": "22071001720",
    "LE": 71
  },
  {
    "geoid": "22071001722",
    "LE": 73
  },
  {
    "geoid": "22071001723",
    "LE": 78
  },
  {
    "geoid": "22071001724",
    "LE": 68
  },
  {
    "geoid": "22071001725",
    "LE": 77
  },
  {
    "geoid": "22071001735",
    "LE": 72
  },
  {
    "geoid": "22071001737",
    "LE": 75
  },
  {
    "geoid": "22071001739",
    "LE": 75
  },
  {
    "geoid": "22071001740",
    "LE": 76
  },
  {
    "geoid": "22071001741",
    "LE": 72
  },
  {
    "geoid": "22071001743",
    "LE": 72
  },
  {
    "geoid": "22071001744",
    "LE": 71
  },
  {
    "geoid": "22071001745",
    "LE": 73
  },
  {
    "geoid": "22071001746",
    "LE": 69
  },
  {
    "geoid": "22071001747",
    "LE": 82
  },
  {
    "geoid": "22071001748",
    "LE": 76
  },
  {
    "geoid": "22071001749",
    "LE": 78
  },
  {
    "geoid": "22071001750",
    "LE": 75
  },
  {
    "geoid": "22071001751",
    "LE": 74
  },
  {
    "geoid": "22071001900",
    "LE": 72
  },
  {
    "geoid": "22071002000",
    "LE": 65
  },
  {
    "geoid": "22071002200",
    "LE": 71
  },
  {
    "geoid": "22071002300",
    "LE": 70
  },
  {
    "geoid": "22071002401",
    "LE": 78
  },
  {
    "geoid": "22071002402",
    "LE": 72
  },
  {
    "geoid": "22071002501",
    "LE": 75
  },
  {
    "geoid": "22071002502",
    "LE": 73
  },
  {
    "geoid": "22071002503",
    "LE": 78
  },
  {
    "geoid": "22071002504",
    "LE": 76
  },
  {
    "geoid": "22071002600",
    "LE": 80
  },
  {
    "geoid": "22071002700",
    "LE": 65
  },
  {
    "geoid": "22071002800",
    "LE": 68
  },
  {
    "geoid": "22071002900",
    "LE": 64
  },
  {
    "geoid": "22071003000",
    "LE": 68
  },
  {
    "geoid": "22071003100",
    "LE": 68
  },
  {
    "geoid": "22071003301",
    "LE": 73
  },
  {
    "geoid": "22071003302",
    "LE": 79
  },
  {
    "geoid": "22071003303",
    "LE": 75
  },
  {
    "geoid": "22071003308",
    "LE": 73
  },
  {
    "geoid": "22071003400",
    "LE": 73
  },
  {
    "geoid": "22071003500",
    "LE": 68
  },
  {
    "geoid": "22071003600",
    "LE": 70
  },
  {
    "geoid": "22071003702",
    "LE": 81
  },
  {
    "geoid": "22071003800",
    "LE": 78
  },
  {
    "geoid": "22071003900",
    "LE": 74
  },
  {
    "geoid": "22071004000",
    "LE": 77
  },
  {
    "geoid": "22071004100",
    "LE": 80
  },
  {
    "geoid": "22071004401",
    "LE": 66
  },
  {
    "geoid": "22071004500",
    "LE": 72
  },
  {
    "geoid": "22071004600",
    "LE": 79
  },
  {
    "geoid": "22071004900",
    "LE": 71
  },
  {
    "geoid": "22071005400",
    "LE": 78
  },
  {
    "geoid": "22071005500",
    "LE": 84
  },
  {
    "geoid": "22071005601",
    "LE": 83
  },
  {
    "geoid": "22071005602",
    "LE": 88
  },
  {
    "geoid": "22071005603",
    "LE": 79
  },
  {
    "geoid": "22071005604",
    "LE": 80
  },
  {
    "geoid": "22071006300",
    "LE": 75
  },
  {
    "geoid": "22071006400",
    "LE": 77
  },
  {
    "geoid": "22071006500",
    "LE": 77
  },
  {
    "geoid": "22071006900",
    "LE": 67
  },
  {
    "geoid": "22071007101",
    "LE": 74
  },
  {
    "geoid": "22071007200",
    "LE": 71
  },
  {
    "geoid": "22071007501",
    "LE": 72
  },
  {
    "geoid": "22071007502",
    "LE": 72
  },
  {
    "geoid": "22071007604",
    "LE": 80
  },
  {
    "geoid": "22071007605",
    "LE": 77
  },
  {
    "geoid": "22071007606",
    "LE": 82
  },
  {
    "geoid": "22071007700",
    "LE": 80
  },
  {
    "geoid": "22071008200",
    "LE": 75
  },
  {
    "geoid": "22071008300",
    "LE": 79
  },
  {
    "geoid": "22071008400",
    "LE": 78
  },
  {
    "geoid": "22071008600",
    "LE": 72
  },
  {
    "geoid": "22071008800",
    "LE": 75
  },
  {
    "geoid": "22071009000",
    "LE": 80
  },
  {
    "geoid": "22071009100",
    "LE": 73
  },
  {
    "geoid": "22071009200",
    "LE": 72
  },
  {
    "geoid": "22071009400",
    "LE": 62
  },
  {
    "geoid": "22071009600",
    "LE": 74
  },
  {
    "geoid": "22071009700",
    "LE": 76
  },
  {
    "geoid": "22071009900",
    "LE": 75
  },
  {
    "geoid": "22071010000",
    "LE": 74
  },
  {
    "geoid": "22071010200",
    "LE": 71
  },
  {
    "geoid": "22071010300",
    "LE": 75
  },
  {
    "geoid": "22071010600",
    "LE": 75
  },
  {
    "geoid": "22071010700",
    "LE": 82
  },
  {
    "geoid": "22071010800",
    "LE": 81
  },
  {
    "geoid": "22071010900",
    "LE": 83
  },
  {
    "geoid": "22071011100",
    "LE": 75
  },
  {
    "geoid": "22071011200",
    "LE": 79
  },
  {
    "geoid": "22071011400",
    "LE": 81
  },
  {
    "geoid": "22071011500",
    "LE": 81
  },
  {
    "geoid": "22071011600",
    "LE": 78
  },
  {
    "geoid": "22071011700",
    "LE": 80
  },
  {
    "geoid": "22071012000",
    "LE": 86
  },
  {
    "geoid": "22071012101",
    "LE": 82
  },
  {
    "geoid": "22071012200",
    "LE": 80
  },
  {
    "geoid": "22071012300",
    "LE": 74
  },
  {
    "geoid": "22071012400",
    "LE": 80
  },
  {
    "geoid": "22071012500",
    "LE": 77
  },
  {
    "geoid": "22071012600",
    "LE": 79
  },
  {
    "geoid": "22071012700",
    "LE": 78
  },
  {
    "geoid": "22071012800",
    "LE": 74
  },
  {
    "geoid": "22071012900",
    "LE": 75
  },
  {
    "geoid": "22071013000",
    "LE": 77
  },
  {
    "geoid": "22071013100",
    "LE": 73
  },
  {
    "geoid": "22071013301",
    "LE": 85
  },
  {
    "geoid": "22071013302",
    "LE": 80
  },
  {
    "geoid": "22071013400",
    "LE": 78
  },
  {
    "geoid": "22071013600",
    "LE": 68
  },
  {
    "geoid": "22071013700",
    "LE": 66
  },
  {
    "geoid": "22071013800",
    "LE": 69
  },
  {
    "geoid": "22071013900",
    "LE": 81
  },
  {
    "geoid": "22071014000",
    "LE": 72
  },
  {
    "geoid": "22071014200",
    "LE": 76
  },
  {
    "geoid": "22071014300",
    "LE": 69
  },
  {
    "geoid": "22071014400",
    "LE": 77
  },
  {
    "geoid": "22075050100",
    "LE": 75
  },
  {
    "geoid": "22075050200",
    "LE": 78
  },
  {
    "geoid": "22075050300",
    "LE": 77
  },
  {
    "geoid": "22075050500",
    "LE": 71
  },
  {
    "geoid": "22075050600",
    "LE": 71
  },
  {
    "geoid": "22075050800",
    "LE": 72
  },
  {
    "geoid": "22087030103",
    "LE": 72
  },
  {
    "geoid": "22087030104",
    "LE": 73
  },
  {
    "geoid": "22087030203",
    "LE": 73
  },
  {
    "geoid": "22087030204",
    "LE": 71
  },
  {
    "geoid": "22087030206",
    "LE": 73
  },
  {
    "geoid": "22087030207",
    "LE": 78
  },
  {
    "geoid": "22087030208",
    "LE": 77
  },
  {
    "geoid": "22087030209",
    "LE": 76
  },
  {
    "geoid": "22087030300",
    "LE": 76
  },
  {
    "geoid": "22087030400",
    "LE": 74
  },
  {
    "geoid": "22087030500",
    "LE": 74
  },
  {
    "geoid": "22087030602",
    "LE": 74
  },
  {
    "geoid": "22087030700",
    "LE": 75
  },
  {
    "geoid": "22087030800",
    "LE": 72
  },
  {
    "geoid": "22089060100",
    "LE": 78
  },
  {
    "geoid": "22089062100",
    "LE": 79
  },
  {
    "geoid": "22089062301",
    "LE": 77
  },
  {
    "geoid": "22089062302",
    "LE": 80
  },
  {
    "geoid": "22089062400",
    "LE": 72
  },
  {
    "geoid": "22089062500",
    "LE": 76
  },
  {
    "geoid": "22089062700",
    "LE": 75
  },
  {
    "geoid": "22089062800",
    "LE": 72
  },
  {
    "geoid": "22089062900",
    "LE": 76
  },
  {
    "geoid": "22089063000",
    "LE": 77
  },
  {
    "geoid": "22089063100",
    "LE": 79
  },
  {
    "geoid": "22089063200",
    "LE": 75
  },
  {
    "geoid": "22093040100",
    "LE": 75
  },
  {
    "geoid": "22093040200",
    "LE": 75
  },
  {
    "geoid": "22093040300",
    "LE": 80
  },
  {
    "geoid": "22093040400",
    "LE": 74
  },
  {
    "geoid": "22093040500",
    "LE": 75
  },
  {
    "geoid": "22093040600",
    "LE": 77
  },
  {
    "geoid": "22093040700",
    "LE": 79
  },
  {
    "geoid": "22095070100",
    "LE": 81
  },
  {
    "geoid": "22095070200",
    "LE": 73
  },
  {
    "geoid": "22095070300",
    "LE": 76
  },
  {
    "geoid": "22095070400",
    "LE": 78
  },
  {
    "geoid": "22095070500",
    "LE": 72
  },
  {
    "geoid": "22095070600",
    "LE": 75
  },
  {
    "geoid": "22095070700",
    "LE": 75
  },
  {
    "geoid": "22095070800",
    "LE": 70
  },
  {
    "geoid": "22095070900",
    "LE": 73
  },
  {
    "geoid": "22095071000",
    "LE": 72
  },
  {
    "geoid": "22095071100",
    "LE": 75
  },
  {
    "geoid": "22103040102",
    "LE": 75
  },
  {
    "geoid": "22103040103",
    "LE": 76
  },
  {
    "geoid": "22103040104",
    "LE": 77
  },
  {
    "geoid": "22103040201",
    "LE": 78
  },
  {
    "geoid": "22103040202",
    "LE": 78
  },
  {
    "geoid": "22103040303",
    "LE": 79
  },
  {
    "geoid": "22103040304",
    "LE": 83
  },
  {
    "geoid": "22103040305",
    "LE": 80
  },
  {
    "geoid": "22103040400",
    "LE": 81
  },
  {
    "geoid": "22103040501",
    "LE": 74
  },
  {
    "geoid": "22103040502",
    "LE": 77
  },
  {
    "geoid": "22103040601",
    "LE": 78
  },
  {
    "geoid": "22103040602",
    "LE": 78
  },
  {
    "geoid": "22103040604",
    "LE": 81
  },
  {
    "geoid": "22103040605",
    "LE": 79
  },
  {
    "geoid": "22103040701",
    "LE": 78
  },
  {
    "geoid": "22103040705",
    "LE": 75
  },
  {
    "geoid": "22103040706",
    "LE": 75
  },
  {
    "geoid": "22103040709",
    "LE": 76
  },
  {
    "geoid": "22103040710",
    "LE": 79
  },
  {
    "geoid": "22103040801",
    "LE": 76
  },
  {
    "geoid": "22103040803",
    "LE": 75
  },
  {
    "geoid": "22103040900",
    "LE": 69
  },
  {
    "geoid": "22103041002",
    "LE": 77
  },
  {
    "geoid": "22103041003",
    "LE": 78
  },
  {
    "geoid": "22103041004",
    "LE": 76
  },
  {
    "geoid": "22103041101",
    "LE": 75
  },
  {
    "geoid": "22103041102",
    "LE": 75
  },
  {
    "geoid": "22103041103",
    "LE": 69
  },
  {
    "geoid": "22103041104",
    "LE": 75
  },
  {
    "geoid": "22103041202",
    "LE": 76
  },
  {
    "geoid": "22103041204",
    "LE": 75
  },
  {
    "geoid": "22103041207",
    "LE": 78
  },
  {
    "geoid": "22103041208",
    "LE": 83
  },
  {
    "geoid": "22103041209",
    "LE": 80
  },
  {
    "geoid": "22103041210",
    "LE": 76
  },
  {
    "geoid": "22103041211",
    "LE": 78
  },
  {
    "geoid": "22103041300",
    "LE": 81
  }
]
